<script setup>
    /**
     * Vue Scripts
     */
    import {computed} from "vue";
    import {trialListingStore} from "@pinia/trial-listing-store";

    const store = trialListingStore()

    const {results, showFilters,} = LABELS?.filterLabels?.labels;
    const total = computed(() => store.resultsValues.total || 0)
</script>

<template>
    <div class="results-header">
        <div class="results"
             v-html="`${total} ${results}`"
        />

        <button class="filters-toggle">
            <span class="icon" />
            <span
                class="text"
                v-html="showFilters"
            />
        </button>
    </div>
</template>

<script>
    export default {
        name: "Results Count"
    }
</script>

<style scoped lang="scss">

</style>
